import { SimpleVariable } from "../shared/variableTypes/SimpleVariable";

export class RepeatChildInputConfig {
  Description: string;
  Items: SimpleVariable[];
  Parent: SimpleVariable;
}
